import { ITEM_BASED_FAMILY_KEYS, isDepositBearingSelection } from '../../../services/schedulePreview';
import { resolveDepositMode } from './depositMode';
import type { DepositMode } from './depositMode';
import type { Product, SchedulingMethod } from '@/features/products/types/products.types';

/** `deriveDepositBounds` stays inline in `index.tsx`: it needs `collectionTargets`, which is
 *  itself fed by `effectiveDepositMinor`, so folding it in here would run it in the wrong order. */
export function useDepositDerivation(
    selectedMethod: SchedulingMethod | null,
    selectedProduct: Product | null | undefined,
    depositMinor: number | undefined,
): {
    allowDeposit: boolean;
    isDepositBearing: boolean;
    isItemBasedFamily: boolean;
    isItemBasedDepositBearing: boolean;
    depositMode: DepositMode;
    effectiveDepositMinor: number | undefined;
} {
    const allowDeposit = selectedProduct?.allowDeposit === true;
    const isDepositBearing = isDepositBearingSelection(selectedMethod, allowDeposit);
    const isItemBasedFamily = ITEM_BASED_FAMILY_KEYS.has(selectedMethod?.key ?? '');
    const isItemBasedDepositBearing = isItemBasedFamily && isDepositBearing;

    const depositMode = resolveDepositMode({
        isDepositBearing,
        allowDeposit,
        minMinor: selectedProduct?.minDepositAmountMinor,
        maxMinor: selectedProduct?.maxDepositAmountMinor,
        defaultMinor: selectedProduct?.defaultDepositAmountMinor,
    });

    const effectiveDepositMinor = depositMode.kind === 'fixed' ? depositMode.amountMinor : depositMinor;

    return {
        allowDeposit,
        isDepositBearing,
        isItemBasedFamily,
        isItemBasedDepositBearing,
        depositMode,
        effectiveDepositMinor,
    };
}
